/**
 * en-GB messages added by Phase 1 task W5 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w5EnGB = {
    'error.printer_in_use': 'That printer is still used by a kiosk. Choose another printer for the kiosk first.',
    // Page and tabs
    'devicesUi.title': 'Devices',
    'devicesUi.description': 'Kiosks and printers, their health and alerts.',
    'devicesUi.tabs': 'Devices sections',
    'devicesUi.tab.devices': 'Devices',
    'devicesUi.tab.printers': 'Printers',
    'devicesUi.tab.alerts': 'Alert settings',
    'devicesUi.live.on': 'Live updates on',
    'devicesUi.live.off': 'Live updates paused, reconnecting',
    // Device list
    'devicesUi.filter.site': 'Site',
    'devicesUi.filter.allSites': 'All sites',
    'devicesUi.filter.state': 'Show',
    'devicesUi.filter.stateAll': 'All devices',
    'devicesUi.filter.stateOnline': 'Online',
    'devicesUi.filter.stateOffline': 'Offline',
    'devicesUi.filter.stateAttention': 'Needs attention',
    'devicesUi.col.name': 'Name',
    'devicesUi.col.site': 'Site',
    'devicesUi.col.state': 'Status',
    'devicesUi.col.battery': 'Battery',
    'devicesUi.col.version': 'App version',
    'devicesUi.col.lastSeen': 'Last seen',
    'devicesUi.col.actions': 'Actions',
    'devicesUi.state.online': 'Online',
    'devicesUi.state.offline': 'Offline',
    'devicesUi.alerts.count': '{count} alerts open',
    'devicesUi.alerts.one': '1 alert open',
    'devicesUi.battery.value': '{percent}%',
    'devicesUi.battery.charging': '{percent}%, charging',
    'devicesUi.battery.unknown': 'Not reported',
    'devicesUi.version.value': '{app} (screens {bundle})',
    'devicesUi.version.updateAvailable': 'Update available',
    'devicesUi.neverSeen': 'Not yet',
    'devicesUi.empty': 'No devices yet. Pair a kiosk to get started.',
    'devicesUi.rename': 'Rename',
    'devicesUi.rename.label': 'New name for {name}',
    'devicesUi.unpair': 'Unpair',
    'devicesUi.unpair.confirm': 'Unpair {name}',
    'devicesUi.unpair.done': '{name} was unpaired.',
    // Pairing
    'devicesUi.pair.button': 'Pair a device',
    'devicesUi.pair.title': 'Pair a device',
    'devicesUi.pair.description': 'Choose where the device will be and give it a name. You then get a code to type into the Kiosk app.',
    'devicesUi.pair.site': 'Site',
    'devicesUi.pair.name': 'Device name',
    'devicesUi.pair.kind': 'Type of device',
    'devicesUi.pair.submit': 'Get pairing code',
    'devicesUi.pair.codeTitle': 'Your pairing code',
    'devicesUi.pair.codeLabel': 'Pairing code {code}',
    'devicesUi.pair.expires': 'Enter it on the device before {time}. It works once.',
    'devicesUi.pair.done': 'Done',
    'devicesUi.kind.kiosk': 'Kiosk',
    'devicesUi.kind.display': 'Reception display',
    'devicesUi.kind.companion': 'Companion phone',
    // Printers
    'devicesUi.printers.new': 'Add a printer',
    'devicesUi.printers.empty': 'No printers yet. Add the label printer your kiosk will use.',
    'devicesUi.printers.col.name': 'Name',
    'devicesUi.printers.col.site': 'Site',
    'devicesUi.printers.col.model': 'Model',
    'devicesUi.printers.col.address': 'Address',
    'devicesUi.printers.col.media': 'Labels',
    'devicesUi.printers.col.state': 'Printer status',
    'devicesUi.printers.col.actions': 'Actions',
    'devicesUi.printers.createTitle': 'Add a printer',
    'devicesUi.printers.editTitle': 'Edit {name}',
    'devicesUi.printers.field.name': 'Printer name',
    'devicesUi.printers.field.site': 'Site',
    'devicesUi.printers.field.model': 'Model',
    'devicesUi.printers.field.host': 'IP address or host name',
    'devicesUi.printers.field.hostHint': 'The address of the printer on the site network. The kiosk connects to it directly.',
    'devicesUi.printers.field.port': 'Port',
    'devicesUi.printers.field.media': 'Label roll',
    'devicesUi.printers.field.status': 'Status',
    'devicesUi.printers.submit.create': 'Add printer',
    'devicesUi.printers.deleted': 'Printer deleted.',
    'devicesUi.printers.delete': 'Delete',
    'devicesUi.printers.archived': 'Archived',
    'devicesUi.printers.labelsLeft': '{count} labels left',
    'devicesUi.model.brother_ql_820nwb': 'Brother QL-820NWB',
    'devicesUi.model.brother_ql_other': 'Other Brother QL',
    'devicesUi.media.dk11204_17x54': 'DK-11204 name label, 17 x 54 mm',
    'devicesUi.media.dk11209_29x62': 'DK-11209 label, 29 x 62 mm',
    'devicesUi.media.dk11202_62x100': 'DK-11202 photo badge, 62 x 100 mm',
    'devicesUi.media.dk22205_62x90': 'DK-22205 continuous roll, 62 mm wide',
    'devicesUi.printerState.ready': 'Ready',
    'devicesUi.printerState.no_media': 'Out of labels',
    'devicesUi.printerState.cover_open': 'Cover open',
    'devicesUi.printerState.media_mismatch': 'Wrong label roll',
    'devicesUi.printerState.busy': 'Busy',
    'devicesUi.printerState.error': 'Error',
    'devicesUi.printerState.unreachable': 'Cannot be reached',
    'devicesUi.printerState.unknown': 'Unknown',
    'devicesUi.noPrinter': 'No printer',
    // Alert kinds and settings
    'devicesUi.alertKind.offline': 'Offline',
    'devicesUi.alertKind.battery_low': 'Battery low',
    'devicesUi.alertKind.not_charging': 'Not charging',
    'devicesUi.alertKind.printer_fault': 'Printer fault',
    'devicesUi.alertKind.labels_low': 'Labels running low',
    'devicesUi.alertKind.app_outdated': 'App out of date',
    'devicesUi.alertSettings.title': 'Alert settings',
    'devicesUi.alertSettings.description': 'When a device has a problem, CloudSign emails the site alert address. A value of 0, or off, switches that alert off.',
    'settings.kiosk-devices.pairingCodeMinutes': 'Pairing code lasts (minutes)',
    'settings.kiosk-devices.healthReportSeconds': 'Devices report their health every (seconds)',
    'settings.kiosk-devices.alerts': 'Alerts',
    'settings.kiosk-devices.alerts.offlineMinutes': 'Offline for (minutes)',
    'settings.kiosk-devices.alerts.batteryPercent': 'Battery below (%)',
    'settings.kiosk-devices.alerts.notChargingMinutes': 'Not charging for (minutes)',
    'settings.kiosk-devices.alerts.printerFault': 'Printer fault',
    'settings.kiosk-devices.alerts.labelsLeftBelow': 'Labels left below',
    'settings.kiosk-devices.alerts.appOutdated': 'App out of date',
    'settings.kiosk-devices.monitoring': 'Monitoring',
    'settings.kiosk-devices.monitoring.historyDays': 'Days of history kept (0 keeps none)',
    // Device page
    'devicesUi.detail.back': 'Back to devices',
    'devicesUi.detail.description': '{kind} at {site}',
    'devicesUi.detail.status': 'Status',
    'devicesUi.detail.noHealth': 'This device has not reported yet.',
    'devicesUi.detail.reportedAt': 'Last report {time}',
    'devicesUi.stat.battery': 'Battery',
    'devicesUi.stat.charging': 'Charging',
    'devicesUi.stat.wifi': 'Wi-Fi strength',
    'devicesUi.stat.network': 'Network',
    'devicesUi.stat.storage': 'Free storage',
    'devicesUi.stat.queue': 'Waiting to upload',
    'devicesUi.stat.os': 'Operating system',
    'devicesUi.stat.model': 'Model',
    'devicesUi.stat.app': 'App version',
    'devicesUi.stat.bundle': 'Screens version',
    'devicesUi.stat.lastSignIn': 'Last sign-in handled',
    'devicesUi.stat.lastSeen': 'Last seen',
    'devicesUi.stat.pairedAt': 'Paired',
    'devicesUi.stat.printer': 'Printer',
    'devicesUi.stat.none': 'None',
    'devicesUi.stat.percent': '{value}%',
    'devicesUi.stat.mb': '{value} MB',
    'devicesUi.network.wifi': 'Wi-Fi',
    'devicesUi.network.ethernet': 'Ethernet',
    'devicesUi.network.cellular': 'Mobile data',
    'devicesUi.network.none': 'No connection',
    'devicesUi.network.unknown': 'Unknown',
    'devicesUi.edit.title': 'Device settings',
    'devicesUi.edit.name': 'Name',
    'devicesUi.edit.site': 'Site',
    'devicesUi.edit.siteHint': 'Moving a device makes it fetch the new site settings.',
    'devicesUi.edit.printer': 'Printer',
    'devicesUi.edit.alerts': 'Email alerts for this device',
    'devicesUi.edit.alertsHint': 'Alerts go to the address set on the site.',
    // Remote actions
    'devicesUi.actions.title': 'Remote actions',
    'devicesUi.actions.description': 'Send an instruction to the device. If it is offline it acts as soon as it reconnects, for up to 24 hours.',
    'devicesUi.action.reload_config': 'Reload settings',
    'devicesUi.action.restart_app': 'Restart app',
    'devicesUi.action.test_print': 'Test print',
    'devicesUi.action.show_message': 'Show message',
    'devicesUi.action.unpair': 'Unpair',
    'devicesUi.action.sent': 'Instruction sent: {action}.',
    'devicesUi.action.messageLabel': 'Message to show on screen',
    'devicesUi.action.messageHint': 'Up to 200 characters. Shown over the welcome screen.',
    'devicesUi.action.secondsLabel': 'Show for (seconds)',
    'devicesUi.action.unpairHint': 'The kiosk is wiped and needs a new pairing code to be used again.',
    'devicesUi.commands.title': 'Recent instructions',
    'devicesUi.commands.empty': 'No instructions have been sent.',
    'devicesUi.commands.col.action': 'Instruction',
    'devicesUi.commands.col.sent': 'Sent',
    'devicesUi.commands.col.result': 'Result',
    'devicesUi.commands.waiting': 'Waiting for the device',
    'devicesUi.commands.expired': 'Expired',
    'devicesUi.commands.ok': 'Done',
    'devicesUi.commands.failed': 'Failed',
    // History
    'devicesUi.history.title': 'History',
    'devicesUi.history.range': 'Period',
    'devicesUi.history.days': 'Last {days} days',
    'devicesUi.history.day': 'Last day',
    'devicesUi.history.uptime': 'Uptime',
    'devicesUi.history.uptimeValue': '{percent}%',
    'devicesUi.history.empty': 'No history has been recorded for this period.',
    'devicesUi.chart.online': 'Minutes online each hour',
    'devicesUi.chart.battery': 'Battery level',
    'devicesUi.chart.wifi': 'Wi-Fi strength',
    'devicesUi.chart.signIns': 'Sign-ins handled each hour',
    'devicesUi.chart.summary.online': '{hours} hours online in this period.',
    'devicesUi.chart.summary.battery': 'Average {avg}%, lowest {min}%.',
    'devicesUi.chart.summary.wifi': 'Average {avg}%.',
    'devicesUi.chart.summary.signIns': '{count} sign-ins in this period.',
    'devicesUi.chart.from': 'From {date}',
    'devicesUi.chart.to': 'To {date}',
    // Alert history
    'devicesUi.alertHistory.title': 'Alerts in the last 90 days',
    'devicesUi.alertHistory.empty': 'No alerts.',
    'devicesUi.alertHistory.col.kind': 'Alert',
    'devicesUi.alertHistory.col.opened': 'Opened',
    'devicesUi.alertHistory.col.cleared': 'Cleared',
    'devicesUi.alertHistory.open': 'Still open',
};
//# sourceMappingURL=w5.js.map